import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { Dashboard } from 'api/dashboard';
import { RoutePaths } from 'constant';
import { useDashboardsQuery } from 'queries/dashboard';

export const useDashboardInfo = (): {
  isLoading: boolean;
  allDashboards: Dashboard[];
  selectedDashboard: {
    selectedId: number;
    selectedTitle: string | undefined;
  };
} => {
  const data = useRouteMatch<{ dashboardId: string }>(RoutePaths.dashboardById);
  const { isLoading, data: allDashboards = [] } = useDashboardsQuery();
  const dashboardId = data?.params?.dashboardId ?? '-1';

  return useMemo(() => {
    let selectedId = Number(dashboardId);
    const selectedDashboard = allDashboards.find(
      (d) => d.dashboardId === selectedId,
    );

    if (!isLoading && !selectedDashboard) {
      selectedId = -1;
    }
    const selectedTitle = selectedDashboard?.dashboardName;

    return {
      isLoading,
      allDashboards,
      selectedDashboard: { selectedId, selectedTitle },
    };
  }, [allDashboards, dashboardId, isLoading]);
};
